export const PROXY_WIDTH = 1280;
export const PROXY_HEIGHT = 720;
export const WAVEFORM_PEAKS = 800;
export const DEFAULT_FPS = 30;
export const FRAME_BUFFER_SIZE = 5;
export const FRAME_CACHE_SIZE = 30;
export const LOOK_AHEAD_MS = 500;
export const INITIAL_PX_PER_MS = 0.1; // 100px per second

/** Project canvas aspect ratio presets */
export const ASPECT_PRESETS = [
  { label: 'Original', subtitle: '', value: 0, icon: 'original' },
  { label: '16:9', subtitle: 'YouTube', value: 16 / 9, icon: 'landscape' },
  { label: '4:3', subtitle: 'LinkedIn, Facebook', value: 4 / 3, icon: 'landscape' },
  { label: '2.39:1', subtitle: 'Cinematic', value: 2.39, icon: 'ultrawide' },
  { label: '9:16', subtitle: 'TikTok, Reels', value: 9 / 16, icon: 'portrait' },
  { label: '4:5', subtitle: 'IG / FB Feed', value: 4 / 5, icon: 'portrait' },
  { label: '1:1', subtitle: 'Instagram posts', value: 1, icon: 'square' },
  { label: '3:4', subtitle: 'Pinterest', value: 3 / 4, icon: 'portrait' },
] as const;
